import { initializeI18n } from '@inbody/core';

import commonEn from './constant/common/common.en.json';
import commonKo from './constant/common/common.ko.json';
import archiveActionLogEn from './constant/components/actionLog/archive.actionLog.en.json';
import archiveActionLogKo from './constant/components/actionLog/archive.actionLog.ko.json';
import archiveModalEn from './constant/components/modal/archive.modal.en.json';
import archiveModalKo from './constant/components/modal/archive.modal.ko.json';
import errorEn from './constant/errors/errors.en.json';
import errorKo from './constant/errors/errors.ko.json';

//모든 정적자원 import
import.meta.glob('../../../../../packages/*/src/i18n/index.ts', {
  eager: true,
});

// 네임스페이스 정의
const namespaces = {
  common: 'indrive.common',
  archiveActionLog: 'indrive.archive.actionLog',
  archiveModal: 'indrive.archive.modal',
  errors: 'indrive.errors',
} as const;

// 타입 확장
declare module 'i18next' {
  interface I18nNamespaces {
    [namespaces.common]: typeof commonKo;
    [namespaces.archiveActionLog]: typeof archiveActionLogKo;
    [namespaces.archiveModal]: typeof archiveModalKo;
    [namespaces.errors]: typeof errorKo;
  }
}

// i18n 리소스
export const appResources = {
  ko: {
    [namespaces.common]: commonKo,
    [namespaces.archiveActionLog]: archiveActionLogKo,
    [namespaces.archiveModal]: archiveModalKo,
    [namespaces.errors]: typeof errorKo,
  },
  en: {
    [namespaces.common]: commonKo,
    [namespaces.archiveActionLog]: archiveActionLogEn,
    [namespaces.archiveModal]: archiveModalEn,
    [namespaces.errors]: typeof errorEn,
  },
};

initializeI18n({
  additionalResources: [
    {
      namespace: namespaces.common,
      resources: {
        ko: { [namespaces.common]: commonKo },
        en: { [namespaces.common]: commonEn },
      },
    },
    {
      namespace: namespaces.archiveActionLog,
      resources: {
        ko: { [namespaces.archiveActionLog]: archiveActionLogKo },
        en: { [namespaces.archiveActionLog]: archiveActionLogEn },
      },
    },
    {
      namespace: namespaces.archiveModal,
      resources: {
        ko: { [namespaces.archiveModal]: archiveModalKo },
        en: { [namespaces.archiveModal]: archiveModalEn },
      },
    },
    {
      namespace: namespaces.errors,
      resources: {
        ko: { [namespaces.errors]: errorKo },
        en: { [namespaces.errors]: errorEn },
      },
    },
  ],
});
